import Checkbox from 'components/Checkbox';
import styled from 'styled-components';
import { DISCOUNT_VALUE_TYPE } from 'features/settingService/services/constants';

type Props = {
  value?: DISCOUNT_VALUE_TYPE;
  onChange?: (value: DISCOUNT_VALUE_TYPE) => void;
};

const InputRadioType = ({ value, onChange }: Props) => {
  const options = [
    { label: 'Percent', value: DISCOUNT_VALUE_TYPE.PERCENT },
    { label: 'Dollar', value: DISCOUNT_VALUE_TYPE.DOLLAR },
  ];

  return (
    <Container>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          value={value === option.value}
          onChange={() => onChange?.(option.value)}
          size='large'
        />
      ))}
    </Container>
  );
};

export default InputRadioType;

const Container = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
